export default class AdvancedMap {
    constructor(advancedMap, sorting=null) {
        if (advancedMap instanceof AdvancedMap) {
            this._entries = advancedMap._entries;
            this._size = Object.keys(this._entries).length;
            this.items = advancedMap.items;
            this.setSorting(advancedMap._sorting);
            this.sorted = false;
        }

        if(sorting) {
            this.setSorting(sorting);
        }
    }

    _entries = {
        // hash: [key, value]
    };

    _getHash(key) {
        let hash = '';

        for (let subkey in key) {
            hash += (subkey+'='+key[subkey]+'&')
        }

        return hash;
    }

    _size = 0;

    _sorting = null;
    items = [];

    get size() {
        return this._size;
    }

    getItemsSorted() {
        if (!this.sorted) {
            this.sort();
        }
        return this.items;
    }

    _getHashForKey(key) {
        for (let hash in this._entries) {
            let [entryKey, entryValue] = this._entries[hash];
            let found = true;
            for (let subkey in key) {
                found = found && (key[subkey] === entryKey[subkey]);
            }
            if (found) return hash;
        }

        return null;
    }

    get(key) {
        let hash = this._getHashForKey(key);
        if (hash) return this._entries[hash][1];

        return null;
    }

    set(key, value) {
        let hash = this._getHash(key);

        if (typeof this._entries[hash] === 'undefined') {
            this._size++;
        }

        this._entries[hash] = [key, value];
        //this.sort();
        this.sorted = false;
    }

    delete(key) {
        let hash = this._getHashForKey(key);

        if (hash) {
            delete this._entries[hash];
            //this.sort();
            this.sorted = false;
            this._size--;
        }
    }

    forEach(cb, thisArg) {
        if (typeof cb != 'function') return;

        for (let hash in this._entries) {
            let [key, value] = this._entries[hash];
            cb.call(thisArg, value, key, null);
        }
    }

    setSorting(sortingCallback) {
        this._sorting = sortingCallback;
    }

    sort(sortingCallback=null) {


        //Skip sorting for newly created Map (ROOM_CLIENT_LIST) as many new users are being added in a loop
        if(sortingCallback || this._sorting) {

            var items = [];
            this.forEach(function(user, key, map) {
                items.push(user);
            }, this);

            this._sorting = sortingCallback ? sortingCallback : this._sorting;
            items.sort(this._sorting);

            if(window.__debug === "sorting") console.log("sorting", this._sorting ? this._sorting.name : null, items.length);

            this.items = items;
            this.sorted = true;

        }

    }

}




// WEBPACK FOOTER //
// ./local_modules/advanced_map/index.js